import axios from 'axios'

const gptHost = process.env.REACT_APP_HOST + '/api/v1/gpt'

const FILE_LABELS = { html: 'HTML', css: 'CSS', js: 'JavaScript' }

function systemPrompt (enabledFiles) {
  const fileList = enabledFiles.map((f) => FILE_LABELS[f] || f).join(' and ')
  return `You are helping a CS instructor author a browser-based GUI programming exercise (HTML/CSS/JavaScript) for the VizPI teaching platform, through natural-language conversation.

Always generate all three files - HTML, CSS, and JavaScript - together they form the working page rendered in the student's browser. The student only edits and submits the ${fileList} file(s); the other file(s) are the scaffold their code runs against, so they must still be complete and correct even though the student never sees them as an editable stub.

Rules:
- In the ${fileList} file(s) only: leave the core behavior unimplemented as a STUB for the student to complete (e.g. an empty event handler, a missing CSS rule), with a short comment marking what to add. Never write a working solution there.
- In every other file: write a complete, working implementation consistent with the assignment - not a stub. For example, if the student only edits JavaScript, write full real HTML markup (with the ids/classes the JS needs to select) and full real CSS styling, not placeholders.
- The assignment text should clearly state what the student must build and how it will be checked, in plain instructional language (2-6 sentences or a short numbered list).
- Never write profanity or unrelated content.
- Respond with ONLY a single JSON object, no markdown fences, no prose outside the JSON, matching exactly this shape:
{"assignment": "...", "html": "...", "css": "...", "js": "...", "reply": "..."}
"reply" is a one or two sentence message to show the instructor describing what you generated or changed. Always include all three file keys with real content.`
}

function extractJson (text) {
  if (!text) throw new Error('Empty response')
  const start = text.indexOf('{')
  const end = text.lastIndexOf('}')
  if (start === -1 || end === -1) throw new Error('No JSON object found in response')
  return JSON.parse(text.slice(start, end + 1))
}

// history: array of {role: 'user'|'assistant', content: string}
// current: {assignment, html, css, js} - the exercise's present state, so the
// model can revise it instead of starting over on every turn.
export async function generateGuiExercise (history, current, enabledFiles) {
  const messages = [
    { role: 'system', content: systemPrompt(enabledFiles) },
    {
      role: 'system',
      content: `Current exercise state (may be empty if nothing written yet):\nAssignment: ${current.assignment || '(empty)'}\nHTML: ${current.html || '(empty)'}\nCSS: ${current.css || '(empty)'}\nJS: ${current.js || '(empty)'}`,
    },
    ...history.map((m) => ({ role: m.role, content: m.content })),
  ]

  const response = await axios.post(`${gptHost}/openAI/json`, { messages })
  return extractJson(response.data?.content)
}
